import {useState} from 'react';
import useScrollListener from '@scripttag/widgets/hooks/useScrollListener';
import useBounceAnimation from '@scripttag/widgets/hooks/useBounceAnimation';
import {useWindowSize} from '@scripttag/hooks/useWindowSize';
import {getFirstOpenWidget} from '@scripttag/helpers/sessionHelpers';

/**
 * @param {boolean} open
 * @returns {{isShowBounce: boolean, setCountClickFloatBtn: (value: number) => void}}
 */
export default function useBounceEffect({open}) {
  const {isMobile} = useWindowSize();
  const [isFirstScroll, setIsFirstScroll] = useState(false);
  const [countClickFloatBtn, setCountClickFloatBtn] = useState(() => +open);
  const [isShowBounce, setIsShowBounce] = useBounceAnimation(open);

  useScrollListener({
    callback: () => {
      const isFirstOpenWidget = getFirstOpenWidget();
      if (open || countClickFloatBtn || isFirstScroll || isMobile || isFirstOpenWidget) return;
      setIsShowBounce(true);
      setIsFirstScroll(true);
    },
    dependencies: [isFirstScroll, countClickFloatBtn, open]
  });

  return {isShowBounce, setCountClickFloatBtn};
}
